/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum CurrencySymbol {
  'AUD' = '$',
  'EUR' = '€',
  'GBP' = '£',
  'USD' = '$',
}

export type CurrencyCode = keyof typeof CurrencySymbol;
